import {useRouteLoaderData} from '@remix-run/react'
import type {RootLoaderResponse} from '~/types'
import GotItCookieConsent from './got-it-cookie-consent'
import OptInOutCookieConsent from './opt-in-out-cookie-consent'

export interface CookieConsentProps {
  showOnBottom?: boolean
  showCookieConsentGdpr: boolean
  setShowCookieConsentGdpr: React.Dispatch<React.SetStateAction<boolean>>
}

const componentsMap = {
  'got-it': GotItCookieConsent,
  'opt-in': OptInOutCookieConsent,
  'opt-out': OptInOutCookieConsent,
} as const

type CookieConsentVariation = keyof typeof componentsMap

const isValidVariation = (value: unknown): value is CookieConsentVariation => {
  return typeof value === 'string' && value in componentsMap
}

export default function CookieConsent({
  showOnBottom,
  showCookieConsentGdpr,
  setShowCookieConsentGdpr,
}: CookieConsentProps) {
  const {cookieConsentVariation} = useRouteLoaderData('root') as RootLoaderResponse

  const Component = isValidVariation(cookieConsentVariation)
    ? componentsMap[cookieConsentVariation]
    : componentsMap['got-it']

  return (
    <Component
      setShowCookieConsentGdpr={setShowCookieConsentGdpr}
      showCookieConsentGdpr={showCookieConsentGdpr}
      showOnBottom={showOnBottom}
    />
  )
}
